import { EducationHeader } from "@/components/education/EducationHeader";
import { EducationDomainSection } from "@/components/education/EducationDomainSection";
import { educationDomains } from "@/data/education/educationDomains";
import Navbar from "@/components/Navbar";
import { Card, CardContent } from "@/components/ui/card";
import KnowledgeNetworkStats from "@/components/shared/KnowledgeNetworkStats";
import TeamMembersGrid from "@/components/ispai/TeamMembersGrid";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useState } from "react";
import { InviteColleagueDialog } from "@/components/InviteColleagueDialog";
const EDUCATION_CHANNEL_ID = "5f798989-068c-4de5-945f-ece972cbfc8d";
const networkStats = {
  totalParticipants: 0,
  activeContributors: 0,
  knowledgeBases: 0,
  totalSolutions: 10,
  departments: [{
    name: "K-12 Education",
    participants: 0
  }, {
    name: "Higher Education",
    participants: 0
  }, {
    name: "Workforce Development",
    participants: 0
  }, {
    name: "Digital Learning & AI",
    participants: 0
  }, {
    name: "Policy & Governance",
    participants: 0
  }]
};
const EducationChannel = () => {
  const [inviteDialogOpen, setInviteDialogOpen] = useState(false);
  const {
    data: domainKBs
  } = useQuery({
    queryKey: ["education-channel-kbs"],
    queryFn: async () => {
      const {
        data,
        error
      } = await supabase.from("knowledge_base_domains").select(`
          knowledge_base_id,
          domain_id,
          domains(name, symbol),
          knowledge_bases!inner(id, title, status, deleted_at, creator_id)
        `).eq("knowledge_bases.status", "published").is("knowledge_bases.deleted_at", null);
      if (error) throw error;
      return data;
    }
  });
  return <div className="min-h-screen bg-white">
      <Navbar />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <EducationHeader />

        <TeamMembersGrid members={[]} useProfileAvatars={true} showAskCurt={false} channelId={EDUCATION_CHANNEL_ID} />

        <Card className="mb-12 p-6">
          <CardContent className="p-0">
            <h2 className="text-xl font-semibold mb-4">Dashboard</h2>
            <KnowledgeNetworkStats {...networkStats} channelName="education" />
          </CardContent>
        </Card>

        <EducationDomainSection title="Education Domains" domains={educationDomains} domainKBs={domainKBs} />

        

        <InviteColleagueDialog open={inviteDialogOpen} onOpenChange={setInviteDialogOpen} defaultChannelId={EDUCATION_CHANNEL_ID} defaultChannelName="Education Channel" />
      </div>
    </div>;
};
export default EducationChannel;